import { useEffect, useState } from "react";
import { Badge, Fab, Typography } from "@mui/material";
import Iconify from "../../../components/iconify";

export default function ShopCartFab({ itemCount, onClick }) {
  const [expanded, setExpanded] = useState(false);

  // Briefly expand whenever the cart gains items (or on first render with items).
  useEffect(() => {
    if (!itemCount) {
      setExpanded(false);
      return;
    }
    setExpanded(true);
    const t = setTimeout(() => setExpanded(false), 5000);
    return () => clearTimeout(t);
  }, [itemCount]);

  if (!itemCount) return null;

  return (
    <Fab
      color="primary"
      variant={expanded ? "extended" : "circular"}
      onClick={onClick}
      aria-label="Warenkorb öffnen"
      sx={{
        position: "fixed",
        bottom: { xs: 16, sm: 24 },
        right: { xs: 16, sm: 24 },
        display: { xs: "flex" },
        zIndex: 1200,
        // Smooth shape transition between circular ↔ extended
        transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
        minWidth: expanded ? { xs: 160, sm: 180 } : 56,
        maxWidth: "calc(100vw - 32px)",
        gap: expanded ? 1 : 0,
        px: expanded ? 2.5 : undefined,
        boxShadow: 6,
      }}
    >
      {expanded ? (
        <>
          <Iconify icon="eva:shopping-cart-fill" width={22} sx={{ flexShrink: 0 }} />
          <Typography
            component="span"
            variant="button"
            sx={{ fontWeight: 700, whiteSpace: "nowrap", letterSpacing: 0.3 }}
          >
            Zum Warenkorb ({itemCount})
          </Typography>
        </>
      ) : (
        <Badge badgeContent={itemCount} color="error" max={99}>
          <Iconify icon="eva:shopping-cart-fill" width={26} />
        </Badge>
      )}
    </Fab>
  );
}
